// extracted by mini-css-extract-plugin
module.exports = {"root":"_9ebfa9","bulletPoints":"_8b5d80","title":"_972568","noHover":"_ecd210","tooltip":"_b2cf62"};